import { ErrorMessage } from "formik";
import PropTypes from "prop-types";

const ErrorTextComponent = ({ children }) => {
  return <div className="text-xs text-red-500">{children}</div>;
};

const ErrorText = ({ name }) => {
  return <ErrorMessage name={name} component={ErrorTextComponent} />;
};

ErrorTextComponent.propTypes = {
  children: PropTypes.node,
};
ErrorText.propTypes = {
  name: PropTypes.string,
};

export default ErrorText;
